import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { QuoteRequestService } from '@app/shared/services/quote-request.service';
import { QuotationDeactivationCheckerService } from '@app/shared/services/quotation-deactivation-checker/quotation-deactivation-checker.service';



@Component({
  selector: 'app-quote-expiration-disclaimer-dialog',
  templateUrl: './quote-expiration-disclaimer-dialog.component.html',
  styleUrls: ['./quote-expiration-disclaimer-dialog.component.scss'],
  providers: [QuotationDeactivationCheckerService]
})
export class QuoteExpirationDisclaimerDialogComponent implements OnInit, OnDestroy {

  public sendOfferForm: FormGroup;
  public maxCharacters = 255;
  public minCharacters = 0;
  quoteRequestId: any;
  approvedTerms: number[];
  rejectAll: boolean = false;
  resolveOffers$: Subscription;

  
  constructor(
    public dialogRef: MatDialogRef<QuoteExpirationDisclaimerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public quoteService: QuoteRequestService,
    public quotationDeactivationCheckerService: QuotationDeactivationCheckerService,
  ) { 

  }

  ngOnInit(): void {
    this.sendOfferForm = this.fb.group({
      notes: new FormControl('', [Validators.minLength(this.minCharacters), Validators.maxLength(this.maxCharacters)]),
    });
  }

  ngOnDestroy(): void {
    this.resolveOffers$?.unsubscribe();
  }

  public markOfferReadyForReview() {
    this.dialogRef.close({
      success: true,
      quoteFeedback: this.sendOfferForm.value.notes          
    });
  }

  public getQuoteAcceptanceDisclaimer() {
    return this.quotationDeactivationCheckerService.GetQuoteAcceptanceDisclaimer;
  }
}
